export default "__VITE_ASSET__C9X8UhiX__"